import type {RowData} from 'features/eag-grid';

import {DIRECT_SALE_ITEMS_GRID_COLUMNS} from '../constants/directSaleItemsGridColumns';
import {getStringCellValue} from './getStringCellValue';

/**
 * Maps direct-sale item grid rows to issue-note items (POST /issue-notes). The ''
 * fallbacks mirror the per-row 'issue' action in WorkItemsSegment: the backend only
 * exposes the action on material rows, where both cells are populated.
 */
export const mapRowsToIssueNoteItems = (rows: RowData[]) =>
  rows.map((row) => ({
    warehouseId: getStringCellValue(row, DIRECT_SALE_ITEMS_GRID_COLUMNS.warehouseId) ?? '',
    originItemId: row.id,
    articleId: getStringCellValue(row, DIRECT_SALE_ITEMS_GRID_COLUMNS.articleId) ?? '',
    requestItemOriginEntityType: 'wrh_sale_item' as const,
  }));
